module.exports = __webpack_public_path__ + "img/home.2b815296.svg";